export const useApiPut = async <
  TResponse = unknown,
  TBody extends BodyInit | Record<string, unknown> | null | undefined = Record<string, unknown>
>(
  url: string,
  body: TBody,
  headers: HeadersInit = { 'Content-Type': 'application/json' }
): Promise<{ data: TResponse | null; error: unknown | null }> => {
  try {
    const preparedBody = JSON.stringify(body)

    const data = await useNuxtApp().$api<TResponse>(url, {
      method: 'PUT',
      body: preparedBody,
      headers
    })

    return { data, error: null }
  } catch (error: unknown) {
    if (error instanceof Error && 'response' in error) {
      return { data: null, error: (error as { response: unknown }).response }
    }
    return { data: null, error }
  }
}
